"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postCodeOverseaAutoFill = exports.checkedOverseaAutoFill = void 0;
/* ========================================================================
    Module: Auto-fill forms
 ========================================================================== */
/**
 * 海外応募のチェックによって自動入力をする
 *
 * @returns {void}
 */
const checkedOverseaAutoFill = () => {
    const checkboxElement = document.querySelector(".js-auto-fill-is-overseas");
    const postCodeElement = document.querySelector(".js-auto-fill-post-code");
    const prefecturesElement = document.querySelector(".js-auto-fill-prefectures");
    const cityElement = document.querySelector(".js-auto-fill-city");
    if (!checkboxElement) {
        return;
    }
    checkboxElement.addEventListener("change", (e) => {
        if (!(e.currentTarget instanceof HTMLInputElement) ||
            !e.currentTarget.checked) {
            return;
        }
        console.log();
        if (postCodeElement) {
            postCodeElement.value = "0000000";
        }
        if (prefecturesElement) {
            prefecturesElement.value = "99";
        }
        if (cityElement) {
            cityElement.placeholder = "国名からすべての住所をこの欄にご入力ください";
        }
    });
    checkboxElement.dispatchEvent(new Event("change"));
};
exports.checkedOverseaAutoFill = checkedOverseaAutoFill;
/**
 * 郵便番号に「0000000」を指定で自動入力する
 *
 * @returns {void}
 */
const postCodeOverseaAutoFill = () => {
    const postCodeElement = document.querySelector(".js-auto-fill-sch-post-code");
    const prefecturesElement = document.querySelector(".js-auto-fill-sch-prefectures");
    const addressElement = document.querySelector(".js-auto-fill-sch-address");
    if (!postCodeElement) {
        return;
    }
    postCodeElement.addEventListener("change", (e) => {
        if (!(e.currentTarget instanceof HTMLInputElement) ||
            e.currentTarget.value !== "0000000") {
            return;
        }
        if (prefecturesElement) {
            prefecturesElement.value = "99";
        }
        if (addressElement) {
            addressElement.placeholder =
                "国名からすべての住所をこの欄にご入力ください";
        }
    });
    postCodeElement.dispatchEvent(new Event("change"));
};
exports.postCodeOverseaAutoFill = postCodeOverseaAutoFill;
